import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import GradesList from '../GradesList';
import GradesDetails from '../GradesDetails';
import { GradesProvider } from '../context/GradesContext';

function GradesRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE")

  return (
    <GradesProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<GradesList />} />      {/*  Matches `/Grades` */}
       <Route path=":id" element={<GradesDetails />} />  {/* Matches `/Grades/:id` */}
      </Route>
    </Routes>
    </GradesProvider>
  );
}

export default GradesRouter;
